/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowParallelVIcon32Regular = forwardRef('ArrowParallelVIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M3.145 12.489a1 1 0 0 1-1.415-1.415l5.237-5.236a2.875 2.875 0 0 1 4.066 0l5.237 5.236a1 1 0 0 1-1.415 1.415L10 7.633V26a1 1 0 1 1-2 0V7.633L3.145 12.49Z" }),
        React.createElement("path", { d: "M24 24.367V6a1 1 0 1 0-2 0v18.367l-4.855-4.855a1 1 0 0 0-1.415 1.414l5.237 5.237a2.875 2.875 0 0 0 4.066 0l5.237-5.237a1 1 0 0 0-1.415-1.414L24 24.367Z" })));
});
